export default __webpack_public_path__ + "static/media/night-changes.a335432c.png";